import { JsEnv } from './models/js_env';
import { initTemplatePolyfill } from 'lit-html/polyfills/template_polyfill';
import { isIe } from './util/browser_util';

// babelはECMAScriptの仕様に沿った実装にポリフィールを入れてくれるが、DOM(Web API)に対してポリフィールを入れてくれない
// 以下のDOM(Web API)メソッドはプログラム内で利用されているためポリフィールを入れる必要がある
// 1. Node.append()
// 2. Node.replaceWith()
// 3. Node.after()
// また、レガシーブラウザのみに対してポリフィールを入れる判定がついているため、自分で判定する必要がない
// https://blake.id/why-babel-doesnt-transpile-prepend-append-matches/
import 'mdn-polyfills/Node.prototype.append';
import 'mdn-polyfills/Node.prototype.replaceWith';
import 'mdn-polyfills/Node.prototype.after';

// IEのみに対してtemplateのpolyfillの初期化を行う
if (isIe) {
  initTemplatePolyfill();
}

declare let window: {
  TRYLION: {
    Env: JsEnv;
  };
  __BUILD_VERSION__: string;
};

// TRYLIONグローバル変数から環境毎に必要な設定を読み込む
// resources/templates/view/common/js.html 参照
// このファイルは基本的には各ページのエントリポイントのJS以外からは直接読み込まないように
export const Env = window.TRYLION.Env;
